import './listagem.css';
import { AxiosError } from 'axios';
import api from '../../../services/cle';
import { useEffect, useState } from 'react';
import { Tso, FilterClause } from 'ts-odata';
import { ApiError } from '../../../services/tipos';
import { useAppSelector } from '../../../store/hooks';
import ConsultaLicencaOrganizacaoItens from '../itens';
import { SubmitHandler, useForm } from 'react-hook-form';
import ConsultaLicencaOrganizacaoExclusao from '../exclusao';
import Button from '../../../rxlib/components/buttons/button';
import InputLabel from '../../../rxlib/components/input-label';
import { tratarErroApi } from '../../../rxlib/services/utilitarios';
import { Listagem } from '../../../rxlib/components/layout/listagem';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { SelectLabel } from '../../../rxlib/components/select/select-label';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';
import { AcoesTabela, ConfiguracoesTabela } from '../../../rxlib/components/table';
import { SelectLabelAsync, SelectValue } from '../../../rxlib/components/select/select-label-async';

interface ItemLicencaOrganizacao {
    operador: number;
    valorItem: string;
    idItemLicenca: string;
}

interface FiltrosBase {
    condicao: number;
    dataFinal: string;
    dataInicial: string;
    idOrganizacao: string;
    chaveOrganizacao: string;
}

interface Filtros extends FiltrosBase {
    status: number[];
    itens: ItemLicencaOrganizacao[];
}

interface FiltrosForm extends FiltrosBase {
    status: string;
}

function ConsultaLicencaOrganizacaoOrganizacao() {
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [licencasOrganizacao, setLicencasOrganizacao] = useState<[{}]>([{}]);
    const [idLicencaOrganizacao, setIdLicencaOrganizacao] = useState<string>('');
    const [idItemLicencaOrganizacao, setIdItemLicencaOrganizacao] = useState<string>('');
    const [idItensLicencaOrganizacao, setIdItensLicencaOrganizacao] = useState<number>(0);
    const [ultimoIdItemLicencaOrganizacao, setUltimoIdItemLicencaOrganizacao] = useState<number>(0);
    const [carregandoItensLicencaOrganizacao, setCarregandoItensLicencaOrganizacao] = useState<boolean>(false);
    const [showExclusaoItemLicencaOrganizacao, setShowExclusaoItemLicencaOrganizacao] = useState<boolean>(false);
    const [showItensLicencaOrganizacaoConsulta, setShowItensLicencaOrganizacaoConsulta] = useState<boolean>(false);

    const [itensLicencaOrganizacao, setItensLicencaOrganizacao] = useState<[{ [key: string]: string; }]>([{
        operador: '',
        valorItem: '',
        idItemLicenca: '',
    }]);

    const [filtros, setFiltros] = useState<Filtros>({
        itens: [],
        status: [],
        condicao: 0,
        dataFinal: '',
        dataInicial: '',
        idOrganizacao: '',
        chaveOrganizacao: '',
    });

    const configuracoesTabela: ConfiguracoesTabela = {
        mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
        colunas: [
            { nome: 'Organização', entidadePai: 'Organizacao', campo: 'Nome', tipo: 'string' },
            { nome: 'Sigla', entidadePai: 'Organizacao', campo: 'Sigla', tipo: 'string' },
            { nome: 'Descrição', campo: 'Descricao', tipo: 'string' },
            { nome: 'Chave', campo: 'Chave', tipo: 'string' },
            { nome: 'Id', campo: 'Id', tipo: 'string' },
            { nome: 'Expiração', campo: 'Expiracao', tipo: 'date' },
            { nome: 'Status', campo: 'Status', tipo: 'status' },
            { nome: 'Última alteração', campo: 'DataAlteracao', tipo: 'date' },
            { nome: 'Última consulta da licença', campo: 'DataUltimaConsulta', tipo: 'date' },
        ],
    };

    const configuracoesTabelaItensLicenca: ConfiguracoesTabela = {
        mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
        colunas: [
            { nome: 'Item da licença', campo: 'nomeItemLicenca', tipo: 'string' },
            { nome: 'Operador', campo: 'operador', tipo: 'operador' },
            { nome: 'Valor', campo: 'valorItem', tipo: 'string' },
        ],
    };

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Consulta de licenças da organização', link: '' },
    ];

    const status: SelectValue[] = [
        { value: '1', label: 'Ativo', isDisabled: false },
        { value: '0', label: 'Inativo', isDisabled: false },
    ];

    const condicao: any = [
        { id: '0', nome: 'E' },
        { id: '1', nome: 'OU' },
    ];

    const operador: any = [
        { id: '0', nome: 'Qualquer um' },
        { id: '1', nome: '=' },
        { id: '2', nome: '>' },
        { id: '3', nome: '<' },
    ];

    const { register, handleSubmit } = useForm<FiltrosForm>();

    const handleHideWarning = () => setShowWarning(false);

    const handleHideExclusaoItemLicenca = () => setShowExclusaoItemLicencaOrganizacao(false);

    const handleHideItensLicencaConsulta = () => setShowItensLicencaOrganizacaoConsulta(false);

    const temPermissao = usuarioTemPermissao(token, 'licenca_organizacao_consulta');

    useEffect(() => {
        setCarregando(true);
        if (api.defaults.baseURL) {
            let urlBase = `${api.defaults.baseURL}OData/LicencaOrganizacao`;
            let query: Tso = new Tso(`${api.defaults.baseURL}OData/LicencaOrganizacao`);

            if (!!filtros.chaveOrganizacao) {
                query = query.filter(new FilterClause('organizacao/chave').eq(filtros.chaveOrganizacao));
            }

            if (!!filtros.idOrganizacao) {
                query = query.filter(new FilterClause('idOrganizacao').eq(filtros.idOrganizacao));
            }

            if ((!!filtros.dataInicial) && (!!filtros.dataFinal)) {
                query = query.filter(new FilterClause('date(expiracao)').ge(filtros.dataInicial));
                query = query.filter(new FilterClause('date(expiracao)').le(filtros.dataFinal));
            }

            let request: string = query.toString();
            request = request.replaceAll(`'${filtros.idOrganizacao}'`, `${filtros.idOrganizacao}`);
            request = request.replaceAll(`'${filtros.dataInicial}'`, `${filtros.dataInicial}`);
            request = request.replaceAll(`'${filtros.dataFinal}'`, `${filtros.dataFinal}`);
            request = request.replaceAll('%20', ' ');

            if ((filtros.status.length > 0) && (request === urlBase)) {
                request += '?$filter=id eq id';
            }

            if (filtros.status.length > 0) {
                filtros.status.map((item, index) =>
                    (index === 0)
                        ? request += ` and (status eq ${item}`
                        : request += ` or status eq ${item}`
                )

                request += ')';
            }

            if ((filtros.itens.length > 0) && (request === urlBase)) {
                request += '?$filter=id eq id';
            }

            if (filtros.itens.length > 0) {
                filtros.itens.map((item, index) =>
                    (index === 0)
                        ? request += ` and (${montarFiltroItens(item)}`
                        : filtros.condicao === 0
                            ? request += ` and ${montarFiltroItens(item)}`
                            : request += ` or ${montarFiltroItens(item)}`
                )

                request += ')';
            }

            if (request.includes('filter')) {
                request += '&$expand=organizacao';
            } else {
                request += '?$expand=organizacao';
            }

            api.get(request)
                .then(response => {
                    setTimeout(() => {
                        setLicencasOrganizacao(response.data.value);
                        setCarregando(false);
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                    setShowWarning(true);
                });
        }

        function montarFiltroItens(item: ItemLicencaOrganizacao): string {
            let filtro: string = '';
            if (item.operador === 0) {
                filtro += `ItensLicencaOrganizacao/any(i:i/idItemLicenca eq ${item.idItemLicenca})`
            } else {
                switch (item.operador) {
                    case 1:
                        filtro += `ItensLicencaOrganizacao/any(i:i/idItemLicenca eq ${item.idItemLicenca} and i/valorItem eq '${item.valorItem}')`;
                        break;
                    case 2:
                        filtro += `ItensLicencaOrganizacao/any(i:i/idItemLicenca eq ${item.idItemLicenca} and i/valorItem gt '${item.valorItem}')`;
                        break;
                    case 3:
                        filtro += `ItensLicencaOrganizacao/any(i:i/idItemLicenca eq ${item.idItemLicenca} and i/valorItem lt '${item.valorItem}')`;
                        break;
                }
            }

            return filtro;
        }
    }, [temPermissao, filtros]);

    const onSubmit: SubmitHandler<FiltrosForm> = data => {
        let filtrosValidos = true;
        if (((data.dataInicial === '') && (data.dataFinal !== '')) || ((data.dataFinal === '') && (data.dataInicial !== ''))) {
            setMessageWarning(['Informe um período valido para a consulta.']);
            filtrosValidos = false;
            setShowWarning(true);
        } else if ((data.dataInicial !== '') && (data.dataFinal !== '')) {
            const dataFinal = new Date(data.dataFinal);
            const dataInicial = new Date(data.dataInicial);

            if (dataInicial.getTime() > dataFinal.getTime()) {
                setMessageWarning(['Data inicial maior que a data final.']);
                filtrosValidos = false;
                setShowWarning(true);
            }
        }

        if (filtrosValidos) {
            let itens: ItemLicencaOrganizacao[] = [];

            if ((itensLicencaOrganizacao[0].idItemLicenca !== undefined) && (itensLicencaOrganizacao[0].idItemLicenca !== '')) {
                for (let contador = 0; contador < itensLicencaOrganizacao.length; contador++) {
                    (contador === 0)
                        ? itens[0] = {
                            valorItem: itensLicencaOrganizacao[contador].valorItem,
                            operador: Number(itensLicencaOrganizacao[contador].operador),
                            idItemLicenca: itensLicencaOrganizacao[contador].idItemLicenca,
                        }
                        : itens.push({
                            valorItem: itensLicencaOrganizacao[contador].valorItem,
                            operador: Number(itensLicencaOrganizacao[contador].operador),
                            idItemLicenca: itensLicencaOrganizacao[contador].idItemLicenca,
                        });
                };
            }

            let status: number[] = [];

            if ((data.status.split('|')[0] !== undefined) && (data.status.split('|')[0] !== '')) {
                status = data.status.split('|').map(Number);
            }

            let filtros: Filtros = {
                itens: itens,
                status: status,
                dataFinal: data.dataFinal,
                dataInicial: data.dataInicial,
                condicao: Number(data.condicao),
                idOrganizacao: data.idOrganizacao,
                chaveOrganizacao: data.chaveOrganizacao,
            }

            setFiltros(filtros);
        }
    }

    const onSubmitItem: SubmitHandler<ItemLicencaOrganizacao> = data => {
        setCarregandoItensLicencaOrganizacao(true);
        api.get(`/ItemLicenca/${data.idItemLicenca}`)
            .then(response => {
                setTimeout(() => {
                    let itens: any = itensLicencaOrganizacao;
                    let proximoId: number = ultimoIdItemLicencaOrganizacao + 1;

                    let item: any = {
                        id: proximoId,
                        operador: data.operador,
                        valorItem: data.valorItem,
                        idItemLicenca: data.idItemLicenca,
                        nomeItemLicenca: response.data.nome,
                    }

                    if (itens[0].id === undefined) {
                        itens[0] = item;
                    } else {
                        itens.push(item);
                    }

                    setItensLicencaOrganizacao(itens);
                    setCarregandoItensLicencaOrganizacao(false);
                    setUltimoIdItemLicencaOrganizacao(proximoId);
                }, 250);
            }).catch((error: AxiosError<ApiError>) => {
                setCarregandoItensLicencaOrganizacao(false);
                setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a inclusão do tem da licença: '));
                setShowWarning(true);
            });
    }

    function handleExcluir(id: string) {
        setIdItensLicencaOrganizacao(Number(id));
        let itemLicencaOrganizacao: any = itensLicencaOrganizacao.find(item => String(item.id) === String(id));

        if (itemLicencaOrganizacao) {
            setIdItemLicencaOrganizacao(itemLicencaOrganizacao.idItemLicenca);
        }

        setShowExclusaoItemLicencaOrganizacao(true);
    }

    function handleItensLicencaConsulta(id: string) {
        setIdLicencaOrganizacao(id);
        setShowItensLicencaOrganizacaoConsulta(true);
    }

    function obterAcoesPersonalizadas(): AcoesTabela[] {
        const acoesPersonalizadas: AcoesTabela[] = [];

        if (usuarioTemPermissao(token, 'itens_licenca_organizacao_visualizar')) {
            acoesPersonalizadas.push({ onClick: handleItensLicencaConsulta, nome: 'Itens da licença', iconeClassName: 'fas fa-book me-3', campo: 'Id' });
        }

        return acoesPersonalizadas;
    }

    function tratarErro(error: AxiosError<ApiError>, mensagem: string) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, mensagem));
        setShowWarning(true);
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <div className='container-fluid'>
                    <div className='row px-1 mt-1'>
                        <div className='col-6'>
                            <div className='container-fluid naja-conteiner-filtros'>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className='row mt-1'>
                                        <div className='col-6'>
                                            <InputLabel
                                                type='text'
                                                maxLength={10}
                                                readOnly={false}
                                                autoFocus={true}
                                                required={false}
                                                referencia={register()}
                                                name='chaveOrganizacao'
                                                id='inputChaveOrganizacao'
                                                label='Chave da organização:'
                                                placeholder='Chave da organização'
                                                className='rxlib-input-label-coluna' />
                                        </div>
                                        <div className='col-6'>
                                            <SelectLabelAsync
                                                action=''
                                                foco='nao'
                                                required='nao'
                                                type='Organizacao'
                                                label='Organização:'
                                                name='idOrganizacao'
                                                id='inputIdOrganizacao'
                                                referencia={register()}
                                                className='rxlib-select-label-coluna' />
                                        </div>
                                    </div>
                                    <div className='row mt-1'>
                                        <div className='col-6'>
                                            <InputLabel
                                                type='date'
                                                maxLength={10}
                                                defaultValue=''
                                                readOnly={false}
                                                required={false}
                                                id='dataInicial'
                                                autoFocus={false}
                                                name='dataInicial'
                                                referencia={register()}
                                                placeholder='  /  /    '
                                                label='Data de validade inicial:'
                                                className='rxlib-input-label-coluna' />
                                        </div>
                                        <div className='col-6'>
                                            <InputLabel
                                                type='date'
                                                maxLength={10}
                                                id='dataFinal'
                                                defaultValue=''
                                                readOnly={false}
                                                required={false}
                                                name='dataFinal'
                                                autoFocus={false}
                                                referencia={register()}
                                                placeholder='  /  /    '
                                                label='Data de validade final:'
                                                className='rxlib-input-label-coluna' />
                                        </div>
                                    </div>
                                    <div className='row mt-1'>
                                        <div className='col-6'>
                                            <SelectLabelAsync
                                                action=''
                                                foco='nao'
                                                name='status'
                                                required='nao'
                                                isMulti={true}
                                                dados={status}
                                                label='Status:'
                                                id='inputStaus'
                                                type='DadosFixos'
                                                valorSelecionado=''
                                                defaultOptions={true}
                                                referencia={register()}
                                                className='rxlib-select-label-coluna' />
                                        </div>
                                        <div className='col-6'>
                                            <SelectLabel
                                                action=''
                                                foco='nao'
                                                name='condicao'
                                                itens={condicao}
                                                label='Condição:'
                                                id='inputCondicao'
                                                ariaLabel='Condição'
                                                referencia={register()}
                                                campoExibicaoRegistro='nome'
                                                campoIdentificadorRegistro='id'
                                                valorSelecionado={condicao[0]['id']}
                                                className='rxlib-select-label-coluna' />
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col-3 rxlib-celula-botao'>
                                            <Button
                                                type='submit'
                                                texto='Consultar'
                                                classStyle='btn-rxlib' />
                                        </div>
                                        <div className='col-9'></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='container-fluid naja-conteiner-filtros naja-filtro-itens-licenca'>
                                <form onSubmit={handleSubmit(onSubmitItem)}>
                                    <div className='row mt-1'>
                                        <div className='col-5'>
                                            <SelectLabelAsync
                                                action=''
                                                foco='nao'
                                                required='sim'
                                                type='ItemLicenca'
                                                name='idItemLicenca'
                                                id='inputIdItemLicenca'
                                                referencia={register()}
                                                label='Itens de licença:'
                                                className='rxlib-select-label-async-coluna' />
                                        </div>
                                        <div className='col-3'>
                                            <SelectLabel
                                                action=''
                                                foco='nao'
                                                required='sim'
                                                name='operador'
                                                itens={operador}
                                                label='Operador:'
                                                id='inputOperador'
                                                ariaLabel='Operador'
                                                referencia={register()}
                                                campoExibicaoRegistro='nome'
                                                campoIdentificadorRegistro='id'
                                                valorSelecionado={operador[0]['id']}
                                                className='rxlib-select-label-coluna' />
                                        </div>
                                        <div className='col-3'>
                                            <InputLabel
                                                type='text'
                                                mask='number'
                                                label='Valor:'
                                                maxLength={50}
                                                required={true}
                                                readOnly={false}
                                                defaultValue='0'
                                                name='valorItem'
                                                autoFocus={false}
                                                id='inputValorItem'
                                                referencia={register()}
                                                placeholder='Valor do item'
                                                className='rxlib-input-label-coluna' />
                                        </div>
                                        <div className='col-1 rxlib-celula-botao'>
                                            <Button
                                                type='submit'
                                                texto='Incluir'
                                                classStyle='btn-rxlib'
                                                className='naja-btn-itens-licenca'
                                                fontAwesomeIcon='fa fa-solid fa-plus' />
                                        </div>
                                    </div>
                                </form>
                                <div className='row mt-1'>
                                    <div className='col-12'>
                                        <Listagem
                                            campoId='id'
                                            tipoBotaoAcao='button'
                                            listagemDetalhe={false}
                                            onExcluir={handleExcluir}
                                            fonteDados={itensLicencaOrganizacao}
                                            className='naja-listagem-itens-licenca'
                                            carregando={carregandoItensLicencaOrganizacao}
                                            configuracoesTabela={configuracoesTabelaItensLicenca} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Listagem
                    campoId='Id'
                    tipoBotaoAcao='button'
                    listagemDetalhe={false}
                    carregando={carregando}
                    fonteDados={licencasOrganizacao}
                    configuracoesTabela={configuracoesTabela}
                    acoesPersonalizadas={obterAcoesPersonalizadas()} />
                <ConsultaLicencaOrganizacaoExclusao
                    tratarErro={tratarErro}
                    onHide={handleHideExclusaoItemLicenca}
                    show={showExclusaoItemLicencaOrganizacao}
                    itensLicencaOrganizacao={itensLicencaOrganizacao}
                    idItemLicencaOrganizacao={idItemLicencaOrganizacao}
                    idItensLicencaOrganizacao={idItensLicencaOrganizacao}
                    setItensLicencaOrganizacao={setItensLicencaOrganizacao} />
                <ConsultaLicencaOrganizacaoItens
                    onHide={handleHideItensLicencaConsulta}
                    show={showItensLicencaOrganizacaoConsulta}
                    idLicencaOrganizacao={idLicencaOrganizacao} />
                <ModalWarning
                    show={showWarning}
                    message={messageWarning}
                    onHide={handleHideWarning} />
                <AcessoBloqueado
                    permissao={temPermissao} />
            </RxlibLayout>
        </>
    );
}

export default ConsultaLicencaOrganizacaoOrganizacao;